import React from 'react';
import { eur } from './donnees';

export default function Classement({ classement, mesure, total }) {
  return (
    <section className="overflow-hidden rounded-2xl border border-slate-200 bg-white" data-testid="stats-classement">
      <div className="px-5 pt-5">
        <h3 className="text-sm font-semibold text-slate-900">Classement des activités</h3>
        <p className="mb-3 text-xs text-slate-500">{classement.length} activité{classement.length > 1 ? 's' : ''}, triées par {mesure === 'ca' ? 'CA des contrats incluant l\'activité' : 'nombre de contrats'}</p>
      </div>
      <div className="max-h-[28rem] overflow-auto">
        <table className="w-full text-sm">
          <thead className="sticky top-0 bg-slate-50 text-left text-[11px] uppercase tracking-wider text-slate-500">
            <tr><th className="px-5 py-2">Rang</th><th className="py-2">Activité</th><th className="py-2">Catégorie</th><th className="py-2 text-right">Contrats</th><th className="py-2 text-right">CA des contrats</th><th className="px-5 py-2">Part</th></tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {classement.map((a, i) => {
              const part = total ? (a[mesure] / total) * 100 : 0;
              return (
                <tr key={a.code} data-testid={`stats-ligne-${a.code}`}>
                  <td className="px-5 py-2 tabular-nums text-slate-500">{i + 1}</td>
                  <td className="py-2"><span className="mr-2 rounded bg-slate-100 px-1.5 py-0.5 font-mono text-[10px] font-bold text-slate-700">{a.code}</span>{a.nom}<div className="text-[11px] text-slate-400">{[...a.territoires].join(' · ')}</div></td>
                  <td className="py-2 text-slate-600">{a.categorie}</td>
                  <td className="py-2 text-right tabular-nums">{a.contrats}</td>
                  <td className="py-2 text-right tabular-nums">{eur(a.ca)}</td>
                  <td className="px-5 py-2"><div className="flex items-center gap-2"><div className="h-1.5 w-24 rounded-full bg-slate-100"><div className="h-1.5 rounded-full bg-slate-800" style={{ width: `${part}%` }} /></div><span className="text-xs tabular-nums text-slate-600">{part.toFixed(1)} %</span></div></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
}
